import Swiper, { Autoplay, FreeMode } from "swiper";

export default {
    init() {
        const speeds = [14000, 16000];
        if (document.querySelector('.section--quotes-slider')) {
            Array.from(document.querySelectorAll('.section--quotes-slider'))
                .forEach(section => {
                    Array.from(section.querySelectorAll('.swiper-posts-quote'))
                        .forEach((el, index) => {
                            let numberOfSlides = Array.from(el.querySelectorAll('.swiper-slide')).length;
                            let autoplayOptions = {
                                delay: 1,
                                disableOnInteraction: false,
                            };

                            el.swiper = new Swiper(el, {
                                modules: [Autoplay, FreeMode],
                                allowTouchMove: true,
                                autoplay: numberOfSlides >= 3 ? autoplayOptions : false,
                                slidesPerView: 1.15,
                                spaceBetween: 20,
                                speed: speeds[index % speeds.length],
                                slidesOffsetBefore: index * 200,
                                breakpoints: {
                                    768: {
                                        slidesPerView: 'auto',
                                    }
                                },
                                freeMode: {
                                    enabled: true,
                                    momentumBounce: false
                                },
                                grabCursor: true,
                                loop: numberOfSlides >= 3,
                                centeredSlides: numberOfSlides === 1
                            });
                        });
                });
        }
    }
}
